var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3451 1.72548C10.7949 0.610612 9.20512 0.61061 8.6549 1.72548L6.82229 5.43873C6.6038 5.88145 6.18145 6.1883 5.69289 6.2593L1.59507 6.85474C0.364738 7.03352 -0.12653 8.54548 0.763746 9.41328L3.72896 12.3037C4.08249 12.6483 4.24381 13.1448 4.16035 13.6313L3.46036 17.7126C3.2502 18.938 4.53634 19.8724 5.63679 19.2939L9.30199 17.367C9.73897 17.1372 10.261 17.1372 10.698 17.367L14.3632 19.2939C15.4637 19.8724 16.7498 18.938 16.5396 17.7126L15.8396 13.6313C15.7562 13.1448 15.9175 12.6483 16.271 12.3037L19.2363 9.41329C20.1265 8.54548 19.6353 7.03352 18.4049 6.85474L14.3071 6.2593C13.8185 6.1883 13.3962 5.88145 13.1777 5.43873L11.3451 1.72548Z",
    fill: "#D32F2F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.5aae93640b124f0220dd937c6430624d.svg";
export { ForwardRef as ReactComponent };